module.exports = __webpack_public_path__ + "img/building-bg.12529fca.png";